<template>
  <div v-show="visible">
    <!-- 结束检查 -->
    <div class="mask"></div>
    <div class="subject-end">
      <div class="bg-content"></div>
      <div class="dialog-content-alert">
        <p class="title">
          <span>结束检查</span>
          <i class="close-btn-v1"
             title="关闭"
             @click="closeDialog"></i>
        </p>
        <div class="content-body">
          <p v-if="nextAlertVisible">检查结束后，您将无法返回考试，请务必仔细<br>阅读所有屏幕内容！<br><br></p>
          <p v-else>您已选择结束当前检查，<br>但是有 <span>{{unAnswerLen}}</span> 道题未完成试题。但如果您点击“是”您将无法返回此检查。<br><br></p>
          <p>您确定要结束此检查吗？</p>
          <div class="option">
            <a href="javascript:void(0);"
               class="a1"
               @click="yesClick">是</a>
            <a href="javascript:void(0);"
               class="a2"
               @click="closeDialog">否</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'examEndAlert',
  props: {
    visible: { type: Boolean },
    unAnswerLen: { type: Number },
  },
  data() {
    return {
      nextAlertVisible: false,
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
      this.nextAlertVisible = false
    },
    yesClick() {
      if (this.visible && !this.nextAlertVisible) {
        // 第一步
        this.nextAlertVisible = true
      } else {
        // 第二步
        this.$emit('update:visible', false)
        this.nextAlertVisible = false
        this.$emit('submit')
      }
    },
  },
  mounted() {
    const { siteCourseID, courseID } = this.$route.query
    this.courseID = Number(courseID)
    this.siteCourseID = Number(siteCourseID)
  },
}
</script>
